import { Injectable, inject } from '@angular/core';
import { TwcRefreshLayerPluginService } from '../../../twc.refresh-layer-plugin.service';
import { HIGH_ICE_WATER_LEGEND } from './high-ice-water.legend';
import { HIGH_ICE_WATER_PRODUCT_DATA } from './high-ice-water.twc-product-data';

@Injectable({
  providedIn: 'root'
})
export class HighIceWaterPluginService {
  private _twcPluginService = inject(TwcRefreshLayerPluginService);
  plugin$ = this._twcPluginService.create(HIGH_ICE_WATER_PRODUCT_DATA, {
    legend: HIGH_ICE_WATER_LEGEND,
    twcLayerTypes: ['web-tile']
  });
}
